import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatButton, MatAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatList, MatListItem } from '@angular/material/list';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { NgIf } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

const material = [
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
  MatButton,
  MatIcon,
  MatList,
  MatListItem,
  MatFormField,
  MatLabel,
  MatInput,
  MatOption,
  MatCheckbox,
  MatChipListbox,
  MatChipOption,
  MatAnchor,
  MatSelect,
  MatDialogModule,
  MatProgressSpinnerModule,
  MatTooltipModule,
  MatError,
];

const forms = [FormsModule, ReactiveFormsModule];

const misc = [NgIf, NgxMaskDirective];

@NgModule({
  declarations: [],
  imports: [CommonModule, ...material, ...forms, ...misc],
  exports: [...material, ...forms, ...misc],
  providers: [provideNgxMask()],
})
export class SharedModule {}
